import React from 'react';

const s = {
  mark: 'bg-yellow-400 text-black font-bold rounded-[2px] px-[1px]',
} as const;

/**
 * Wraps the first occurrence of `query` inside `text` in a yellow <mark>.
 * Returns a plain string when there is no match or the query is empty.
 */
export function highlightText(text: string, query: string): React.ReactNode {
  if (!query.trim()) {
    return text;
  }
  const q = query.toLowerCase().trim();
  const lower = text.toLowerCase();
  const idx = lower.indexOf(q);
  if (idx === -1) {
    return text;
  }
  return (
    <>
      {text.slice(0, idx)}
      <mark className={s.mark}>{text.slice(idx, idx + q.length)}</mark>
      {text.slice(idx + q.length)}
    </>
  );
}
